var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 13.3334C9.89016 13.334 9.78144 13.313 9.67991 13.2715C9.57838 13.2301 9.48603 13.169 9.40816 13.0917L4.40816 8.09174C4.25124 7.93482 4.16309 7.72199 4.16309 7.50007C4.16309 7.27816 4.25124 7.06533 4.40816 6.90841C4.56508 6.75149 4.77791 6.66333 4.99983 6.66333C5.22175 6.66333 5.43458 6.75149 5.5915 6.90841L9.99983 11.3251L14.4082 6.91674C14.5676 6.78022 14.7726 6.70888 14.9824 6.71698C15.1921 6.72508 15.3911 6.81203 15.5395 6.96044C15.6879 7.10885 15.7748 7.3078 15.7829 7.51753C15.791 7.72726 15.7197 7.93232 15.5832 8.09174L10.5832 13.0917C10.4279 13.2457 10.2184 13.3325 9.99983 13.3334Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.7daa62b6bf7c0803a869b834ea93f062.svg";
export { ForwardRef as ReactComponent };